/* eslint-disable no-param-reassign */
import suppliers from 'screens/Suppliers/reducer';
import { createAction, createReducer } from 'utils/reducer';
import moment from 'moment';

const PATH = 'scheduleManagement/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_RECEIPT = `${PATH}TOGGLE_EDIT_RECEIPT`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;
const TOGGLE_EXPAND_ROW = `${PATH}TOGGLE_EXPAND_ROW`;
const TOGGLE_DELETE_LINE = `${PATH}TOGGLE_DELETE_LINE`;

export const SCHEDULE_MANAGEMENT = {
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  SET_FILTERS: `${PATH}SET_FILTERS`,
  GET_BOOKINGS_SUCCESS: `${PATH}GET_BOOKINGS_SUCCESS`,
  CHANGE_FILTERS: `${PATH}CHANGE_FILTERS`,
  CHANGE_PAGINATION: `${PATH}CHANGE_PAGINATION`,
  CREATE_RECEIPT: `${PATH}CREATE_RECEIPT`,
  CREATE_RECEIPT_LOTS: `${PATH}CREATE_RECEIPT_LOTS`,
  EDIT_RECEIPT: `${PATH}EDIT_RECEIPT`,
  EDIT_RECEIPT_DATA: `${PATH}EDIT_RECEIPT_DATA`,
  DELETE_RECEIPT: `${PATH}DELETE_RECEIPT`,
  TOGGLE_DELETE: `${PATH}TOGGLE_DELETE`,
  TOGGLE_DELETE_LOT: `${PATH}TOGGLE_DELETE_LOT`,
  DELETE_LOT: `${PATH}DELETE_LOT`,
  EXPORT_BOOKINGS: `${PATH}EXPORT_BOOKINGS`,
  EXPORT_BOOKINGS_SUCCESS: `${PATH}EXPORT_BOOKINGS_SUCCESS`,
  TOGGLE_EDIT_BOOKING: `${PATH}TOGGLE_EDIT_BOOKING`,
   UPDATE_BOOKING: `${PATH}UPDATE_BOOKING`,
   COMPLETE_BOOKING: `${PATH}COMPLETE_BOOKING`,
   TOGGLE_COMPLETE_MODAL: `${PATH}TOGGLE_COMPLETE_MODAL`,
   GET_BOOKINGS: `${PATH}GET_BOOKINGS`,
 };

export const scheduleManagementActions = {
  setFilters: createAction(SCHEDULE_MANAGEMENT.SET_FILTERS, 'filters'),
  toggleScheduleForm: createAction(TOGGLE_FORM, 'modal'),
  changeScheduleControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_RECEIPT, 'item', 'repeat'),
  setScheduleInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  toggleExpandRow: createAction(TOGGLE_EXPAND_ROW, 'id'),
  toggleDeleteLine: createAction(TOGGLE_DELETE_LINE, 'booking', 'lineIndex'),

  changeFilters: createAction(SCHEDULE_MANAGEMENT.CHANGE_FILTERS, 'filter'),
  paginationControls: createAction(SCHEDULE_MANAGEMENT.CHANGE_PAGINATION, 'filters', 'pagination'),
  getStateFromApi: createAction(SCHEDULE_MANAGEMENT.GET_STATE_FROM_API, 'filters', 'pagination'),
  createReceipt: createAction(SCHEDULE_MANAGEMENT.CREATE_RECEIPT, 'controls'),
  createReceiptLots: createAction(SCHEDULE_MANAGEMENT.CREATE_RECEIPT_LOTS, 'receiptId', 'lots', 'device'),
  editReceipt: createAction(SCHEDULE_MANAGEMENT.EDIT_RECEIPT, 'id', 'controls', 'totalWeight'),
  editReceiptData: createAction(SCHEDULE_MANAGEMENT.EDIT_RECEIPT_DATA, 'id', 'controls'),
  deleteReceipt: createAction(SCHEDULE_MANAGEMENT.DELETE_RECEIPT, 'id'),
  toggleDeleteLot: createAction(SCHEDULE_MANAGEMENT.TOGGLE_DELETE_LOT, 'id'),
  deleteLot: createAction(SCHEDULE_MANAGEMENT.DELETE_LOT, 'id'),
  exportBookings: createAction(SCHEDULE_MANAGEMENT.EXPORT_BOOKINGS),
  toggleEditBooking: createAction(SCHEDULE_MANAGEMENT.TOGGLE_EDIT_BOOKING, 'booking'),
  updateBooking: createAction(SCHEDULE_MANAGEMENT.UPDATE_BOOKING, 'id', 'controls'),
  completeBooking: createAction(SCHEDULE_MANAGEMENT.COMPLETE_BOOKING, 'id', 'arrivalAt', 'arrivalDate'),
  toggleCompleteModal: createAction(SCHEDULE_MANAGEMENT.TOGGLE_COMPLETE_MODAL, 'id'),
};

const defaultInvalidInputs = {
  supplierId: false,
  varietyId: false,
  date: false,
  operationType: false,
  processingSiteId: false,
  carrierId: false,
  superSack: false,
  arrivalFieldAt: false,
  arrivalProcessingPlant: false,
}

const defaultControls = {
  supplierId: '',
  varietyId: '',
  date: '',
  operationType: 'PICKUP',
  needCarrier: true,
  processingSiteId: '',
  carrierId: '',
  superSack: '',
  arrivalFieldAt: '',
  arrivalProcessingPlant: '',
  returnBins: '',
  binsQty: 0,
  lines: [
    {
      truckType: '',
      loadCondition: '',
      binsQty: '',
      binsEmptyQty: '',
      dateTimeArrivedPlants: '',
      dateTimeArrivedField: '',
    }
  ],
}

const initialState = {
  error: false,
  loading: false,
  filters: {
    fromDate: moment().startOf('day').toDate(),
    toDate: moment().endOf('day').toDate(),
    producer: null,
    carrier: null,
    loadCondition: null,
    operationType: null,
    processingSite: null,
    state: null,
  },
  bookings: [],
  bookingsCount: 0,
  bookingsSummary: {},
  pagination: {
    page: 0,
    rowsPerPage: 10,
    count: 0,
  },
  formControls: defaultControls,
  invalidControls: defaultInvalidInputs,
  bookingFormIsOpen: false,
  edit: false,
  bookingIdToEdit: null,
  completeIsOpen: false,
  bookingIdToComplete: null,
  deleteIsOpen: false,
  toDeleteId: null,
  plants: [],
  carriers: [],
  expandedRowId: null,
  lineDeleteIsOpen: false,
  lineToDelete: null,
};



const scheduleManagement = createReducer(initialState, {
  [DISABLE_ERRORS](state, action) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.bookingIdToEdit = null;
    state.formControls = { ...defaultControls, date: moment().format('YYYY-MM-DD') };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  [TOGGLE_EXPAND_ROW](state, action) {
    state.expandedRowId = state.expandedRowId === action.id ? null : action.id;
  },
  [TOGGLE_DELETE_LINE](state, action) {
    state.lineDeleteIsOpen = !state.lineDeleteIsOpen;
    state.lineToDelete = action.booking ? { booking: action.booking, lineIndex: action.lineIndex } : null;
  },
  [SCHEDULE_MANAGEMENT.CHANGE_PAGINATION](state, action) {
    state.loading = true;
    state.pagination = {
      ...state.pagination,
      ...action.pagination,
    };
  },
  [SCHEDULE_MANAGEMENT.CHANGE_FILTERS](state, action) {
    state.loading = true;
    state.filters = {
      ...state.filters,
      ...action.filters,
    };
  },
  [SCHEDULE_MANAGEMENT.GET_STATE_FROM_API](state) {
    state.loading = true;
  },
  [SCHEDULE_MANAGEMENT.GET_STATE_FROM_API_SUCCESS](state, action) {
    state.suppliers = action.payload.objects.suppliers;
    state.entities = action.payload.objects.entities;
    state.varieties = action.payload.objects.varieties;
    state.plants = action.payload.objects.plants;
    state.carriers = action.payload.objects.carriers;
    state.operationTypes = action.payload.objects.operationTypes;
    state.truckTypes = action.payload.objects.truckTypes;
    state.loadConditions = action.payload.objects.loadConditions;
    state.pagination = {
      ...state.pagination,
      ...action.pagination,
    };
  },
  [SCHEDULE_MANAGEMENT.SET_FILTERS](state, action) {
    state.filters = { ...state.filters, ...action.filters };
  },
  [SCHEDULE_MANAGEMENT.GET_BOOKINGS_SUCCESS](state, action) {
    if (action.payload && action.payload.objects && action.payload.objects.appointments) {
      state.bookings = Object.values(action.payload.objects.appointments)
        .sort((a, b) => (b.correlative || b.id) - (a.correlative || a.id));
    } else {
      state.bookings = [];
    }
    state.bookingsCount = action.payload ? action.payload.count || 0 : 0;
    state.pagination = {
      ...state.pagination,
      count: state.bookingsCount,
    };
    state.bookingsSummary = action.payload?.summary ? { ...action.payload.summary } : {};
    state.loading = false;
  },
  [SCHEDULE_MANAGEMENT.TOGGLE_EDIT_BOOKING](state, action) {
    state.bookingFormIsOpen = true;
    state.edit = true;
    state.bookingIdToEdit = action.booking.id;
    state.formControls = {
      ...defaultControls,
      supplierId: action.booking.Supplier?.id,
      varietyId: action.booking.Variety?.id,
      date: action.booking.scheduledAt,
      operationType: action.booking.operationType,
      processingSiteId: action.booking.ProcessingSite?.id || '',
      carrierId: action.booking.Carrier?.id || '',
      needCarrier: !!action.booking.needCarrier,
      superSack: action.booking.superSack || '',
      arrivalFieldAt: action.booking.arrivalFieldAt ? moment(action.booking.arrivalFieldAt).format('HH:mm') : '',
      arrivalProcessingPlant: action.booking.arrivalProcessingPlant ? moment(action.booking.arrivalProcessingPlant).format('HH:mm') : '',
      locationField: action.booking.locationField || '',
      truckType: action.booking.truckType || '',
      loadConditions: action.booking.loadCondition || '',
      binsQty: action.booking.binsQty !== undefined ? action.booking.binsQty : '',
      returnBins: action.booking.returnBins !== undefined ? action.booking.returnBins : '',
      emptyBins: action.booking.binsEmptyQty !== undefined ? action.booking.binsEmptyQty : '',
      lines: (action.booking.AppointmentLines || []).map(line => ({
        id: line.id,
        truckType: line.truckType,
        loadCondition: line.loadCondition,
        binsQty: line.binsQty,
        binsEmptyQty: line.binsEmptyQty || '',
        state: line.state,
        receivedByUserId: line.receivedByUserId,
        needCarrier: line.needCarrier,
      })),
    };
    if (state.formControls.lines.length === 0) {
      state.formControls.lines = [...defaultControls.lines];
    }
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [SCHEDULE_MANAGEMENT.TOGGLE_COMPLETE_MODAL](state, action) {
    state.completeIsOpen = !state.completeIsOpen;
    if (action.id) {
        state.bookingIdToComplete = action.id;
    } else {
        state.bookingIdToComplete = null;
    }
  },
  [SCHEDULE_MANAGEMENT.GET_BOOKINGS](state) {
    state.loading = true;
  },
});

export default scheduleManagement;
